import { ODataResponse } from '@sales-center/common'
import { IImport } from './typings'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { APIError, get, ENTITY_TYPES } from '@sales-center/common'
import { StoreData } from '../reducers/typings'
import buildQuery from 'odata-query'
import { ServiceConfig } from '../services/config'
import { ImportFilterDTO } from '@user/components/Leads/LeadFilters/typings'

const odataUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.import.odata}`
const getFilterEntriesUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.import.getFilterEntries}`
export const getImports = createAsyncThunk<
  ODataResponse<IImport>,
  boolean | undefined,
  { rejectValue: APIError }
>('imports/paged', async (_, thunkApi) => {
  const {
    imports: {
      page,
      perPage,
      filterSet: { orderBy },
    },
  } = thunkApi.getState() as StoreData

  const qstring = buildQuery<IImport>({
    skip: (page - 1) * perPage,
    top: perPage,
    count: page === 1,
    orderBy: orderBy,
  })

  const response = await get(`${odataUrl}${qstring}`)

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const getImportName = createAsyncThunk<
  ImportFilterDTO[],
  ENTITY_TYPES,
  { rejectValue: string }
>('imports/getNames', async (entityType, thunkApi) => {
  const response = await get(`${getFilterEntriesUrl}/${entityType}`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
